
import { MapTo } from '@adobe/aem-react-editable-components';
import FdicBanner, { FdicBannerEditConfig } from './FdicBanner';

export default MapTo('cob-corp-acquisition/components/creditonebank/fdic-banner')(FdicBanner, FdicBannerEditConfig);
        